import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Radio, Settings2, Check, ChevronsUpDown } from "lucide-react";
import api, { getWorkspace, setWorkspace } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export const WorkspaceSwitcher = () => {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const current = getWorkspace();

  useEffect(() => {
    api.get("/workspaces").then((r) => {
      const list = r.data.items || [];
      setItems(list);
      if (list.length && !list.some((w) => w.id === current)) {
        setWorkspace(list[0].id);
        window.location.reload();
      }
    }).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const active = items.find((w) => w.id === current);
  const choose = (id) => {
    if (id === current) return setOpen(false);
    setWorkspace(id);
    window.location.href = "/";
  };
  if (items.length <= 1 && user?.role !== "admin") return null;

  return (
    <div className="px-4 pt-4" data-testid="workspace-switcher">
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <button data-testid="workspace-switcher-button"
                  className="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl bg-[#111827] border border-[#1F2937] hover:border-[#10B981]/50 transition-colors text-left">
            <span className="h-8 w-8 rounded-lg flex items-center justify-center shrink-0" style={{ backgroundColor: (active?.color || "#1E4FD8") + "22", color: active?.color || "#1E4FD8" }}>
              <Radio className="h-4 w-4" />
            </span>
            <span className="flex-1 min-w-0">
              <span className="block text-[10px] uppercase tracking-wide text-slate-500">Canale attivo</span>
              <span className="block text-sm font-semibold text-slate-100 truncate" data-testid="workspace-current-name">{active?.name || "…"}</span>
            </span>
            <ChevronsUpDown className="h-4 w-4 text-slate-500" />
          </button>
        </PopoverTrigger>
        <PopoverContent align="start" className="w-64 p-1.5 bg-white border-slate-200 max-h-[70vh] overflow-y-auto" data-testid="workspace-switcher-menu">
          {items.map((w) => (
            <button key={w.id} onClick={() => choose(w.id)} data-testid={`workspace-option-${w.id}`}
                    className={`w-full flex items-center gap-2 px-2.5 py-2 rounded-lg text-sm text-left hover:bg-slate-100 ${w.id === current ? "bg-slate-50 font-semibold" : ""}`}>
              <span className="h-2.5 w-2.5 rounded-full shrink-0" style={{ backgroundColor: w.color }} />
              <span className="flex-1 min-w-0">
                <span className="block truncate text-slate-800">{w.name}</span>
                <span className="block text-[11px] text-slate-500 truncate">{w.phone_display || (w.wa_configured ? "WhatsApp collegato" : "WhatsApp non configurato")}</span>
              </span>
              {w.id === current && <Check className="h-4 w-4 text-[#1E4FD8]" />}
            </button>
          ))}
          {user?.role === "admin" && (
            <Link to="/canali" onClick={() => setOpen(false)} data-testid="workspace-manage-link"
                  className="mt-1 flex items-center gap-2 px-2.5 py-2 rounded-lg text-sm text-[#1E4FD8] hover:bg-slate-100 border-t border-slate-100">
              <Settings2 className="h-4 w-4" /> Gestisci canali
            </Link>
          )}
        </PopoverContent>
      </Popover>
    </div>
  );
};
